import { DatasetGroup } from "@/queries/datasets/types";
import { useDatasetCardUploadProgress } from "./hooks/useDatasetCardUploadProgress";
import { DatasetCard } from "./DatasetCard";
import { useMemo } from "react";

export const DatasetCardWithProgress = ({
  datasetGroup,
  onClick,
}: {
  datasetGroup: DatasetGroup;
  onClick?: () => void;
}) => {
  const { uploadingProgress } = useDatasetCardUploadProgress(datasetGroup);
  const isDraft = datasetGroup.datasets?.some((d) => d.version_number === -1);

  const loadingState =
    datasetGroup.datasets?.find(
      (d) => d.id === Number(uploadingProgress.dataset_id),
    )?.id === Number(uploadingProgress.dataset_id)
      ? uploadingProgress
      : undefined;

  const getTooltip = useMemo(() => {
    if (isDraft && !Boolean(uploadingProgress?.progress)) {
      return "Latest version is a draft";
    }

    if (loadingState) {
      return `Uploading ${Math.round(loadingState.progress)}%`;
    }

    return "";
  }, [isDraft, loadingState, uploadingProgress]);

  return (
    <DatasetCard
      datasetGroup={datasetGroup}
      onClick={onClick}
      loadingState={loadingState}
      tooltip={getTooltip}
    />
  );
};
